import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { AuthService } from '../user/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CustomerOblivionService {
    
    public baseUrl = '/koncentro-customers/customer-oblivion';

    companyCode: number;

    constructor(
        private http: HttpClientService,
        private authService: AuthService
    ) {
        this.companyCode = authService.user.selectedCompany;
    }

    list(
        offset = null,
        limit = null,
        search?: Array<{ key: string, value: string }>,
        globalSearch?: string,
        sort?: string,
        sort_dir?: number
      ): Observable<any> {
        const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
        return this.http.getPaged(this.baseUrl + '/list?' + params.toString());
      }

    getCustomerOblivionList() {
      return this.http.get(`${this.baseUrl}/list`);
    }

    oblivionCustomer(customerId: number) {
      return this.http.put(`${this.baseUrl}/oblivion/${customerId}`, null);
    }

    recoverCustomer(customerId: number) {
      return this.http.put(`${this.baseUrl}/recover/${customerId}`, null);
    }
      
}


// WEBPACK FOOTER //
// ./src/app/services/customer/customer-oblivion.service.ts